<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="page_v"></a><strong>This book is for</strong></p>
<p class="center"><strong>the FUHRMAN family</strong></p>
<p class="center"><strong>for CHRISANNE</strong></p>
<p class="center"><strong>and for the gang</strong></p>
<p class="noindent"><a id="page_vi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?7721dc58